import Head from 'next/head';
import preview from '../../public/preview/preview-fitkonnekt.png';
import 'animate.css';
import FitKonnektPage from './fit-konnekt-page';
import { Footer, Header } from '../../components';
import menu from '../../utils/menu';

export default function FitKonnekt() {
  return (
    <>
      <Head>
        <title>
          FitKonnekt: A Comprehensive Health and Wellness Platform for Fitness
          Professionals and Enthusiasts
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
        <meta
          property="og:title"
          content="FitKonnekt: A Comprehensive Health and Wellness Platform for Fitness
          Professionals and Enthusiasts"
        />
        <meta property="og:image" content={`${preview.src}`} />
        <meta name="twitter:image" content={`${preview.src}`} />
        <meta
          property="og:image:alt"
          content="FitKonnekt: A Comprehensive Health and Wellness Platform for Fitness
          Professionals and Enthusiasts"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="FitKonnekt empowers fitness professionals and enthusiasts. Learn how FitKonnekt connects trainers, club owners, and people to measure progress, reach health objectives, and change the fitness industry. FitKonnekt offers tailored training regimens, nutrition tracking, progress tracking, and community involvement. Manage appointments, courses, and fitness resources in one location. Join FitKonnekt to live healthier and fitter."
        />
        <meta
          name="description"
          content="FitKonnekt empowers fitness professionals and enthusiasts. Learn how FitKonnekt connects trainers, club owners, and people to measure progress, reach health objectives, and change the fitness industry. FitKonnekt offers tailored training regimens, nutrition tracking, progress tracking, and community involvement. Manage appointments, courses, and fitness resources in one location. Join FitKonnekt to live healthier and fitter."
        />
        <meta
          name="keywords"
          content="FitKonnekt, health and wellness platform, fitness professionals, fitness enthusiasts, fitness industry, personalized workout plans, nutrition tracking, progress monitoring, community engagement, appointment scheduling, class management, fitness resources, health goals, seamless platform, intuitive interface, fitness community, healthier lifestyle, fitter lifestyle, Mavinx health and wellness solution"
        />
      </Head>
      <Header
        appearance="transparent"
        appearanceLogo="fitkonnekt"
        appearanceNav="fitkonnekt"
        menu={menu}
      />
      <FitKonnektPage />
      <Footer line="white" logo="white" variant="fitkonnekt" />
    </>
  );
}
